const getIconName = (iconSrc) => {
  if (!iconSrc) return false;

  return iconSrc.substring(iconSrc.lastIndexOf('/') + 1);
};

export default getIconName;
